import { createContext } from 'react';

const viewContext = createContext({
  mobileView: false,
  tabView: false,
});

export default viewContext;
